module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("I was in my own room as usual")]), _vm._v("—"), _c('i', [_vm._v("just myself, without obvious change: nothing had smitten me, or scathed me, or maimed me. And yet, where was the Jane Eyre of yesterday?")]), _vm._v("—"), _c('i', [_vm._v("where was her life?")]), _vm._v("—"), _c('i', [_vm._v("where were her prospects?")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-a"
  }, [_c('span', [_vm._v("—F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM")]), _vm._v(" "), _c('i', [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YRE")])]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HARLOTTE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RONTË")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("The minute I heard my first love story")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('i', [_vm._v("I started looking for you, not knowing")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('i', [_vm._v("how blind that was")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("Lovers don’t finally meet somewhere")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('i', [_vm._v("They’re in each other all along")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_c('span', [_vm._v("—J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALAL AD")]), _vm._v("-D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMI")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336888be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 72
// module chunks = 0